/**
 * ScrollToTop – skrol na vrh pri promeni rute
 *
 * Osigurava da se pri navigaciji stranica uvek otvori sa skrolom na vrhu.
 * Ne renderuje ništa (return null).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ---------- Komponenta ----------
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // Instant scroll, bez animacije
    });
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;

